import { useState, useEffect } from 'react'
import { Bell, X } from 'lucide-react'

export default function NotificationPermission() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const dismissed = localStorage.getItem('notif-perm-dismissed')
    if (dismissed) return

    if ('Notification' in window && Notification.permission !== 'granted') {
      setShow(true)
    }
  }, [])

  const handleAllow = async () => {
    try {
      const result = await Notification.requestPermission()
      if (result === 'granted') {
        // Init FCM push
        const { initPushNotifications } = await import('../../services/firebase')
        await initPushNotifications()
      }
    } catch (err) {
      console.warn('[NotifPerm] Error:', err)
    }
    setShow(false)
  }

  const handleDismiss = () => {
    localStorage.setItem('notif-perm-dismissed', '1')
    setShow(false)
  }

  if (!show) return null

  return (
    <div className="mx-4 mt-2 mb-2 bg-primary-50 border border-primary-200 rounded-lg p-3">
      <div className="flex items-start gap-3">
        <div className="p-2 bg-primary-100 rounded-full flex-shrink-0">
          <Bell className="h-5 w-5 text-primary-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-gray-900">Enable Notifications</p>
          <p className="text-xs text-gray-600 mt-0.5">
            Get notified about leave approvals, KPI updates, and more.
          </p>
          <div className="flex gap-2 mt-2">
            <button
              onClick={handleAllow}
              className="px-4 py-1.5 bg-primary-600 text-white text-xs font-semibold rounded-lg hover:bg-primary-700 transition-colors"
            >
              Allow
            </button>
            <button
              onClick={handleDismiss}
              className="px-3 py-1.5 text-gray-500 text-xs font-medium hover:text-gray-700 transition-colors"
            >
              Not now
            </button>
          </div>
        </div>
        <button onClick={handleDismiss} className="text-gray-400 hover:text-gray-600 flex-shrink-0">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
